import { render } from "./BidirectionalDemo.vue?vue&type=template&id=05c35a62"
import script from "./BidirectionalDemo.vue?vue&type=script&lang=js"
export * from "./BidirectionalDemo.vue?vue&type=script&lang=js"

import "./BidirectionalDemo.vue?vue&type=style&index=0&id=05c35a62&lang=css"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__